export class AccountStandingResultDto {
    arDue: number;
    category: string;
    ownerCount: number;
    percentage: number;
    title: string;
}
